import type { FocusEvent, KeyboardEvent } from 'react'
import { amountInput } from '../../utils/money'
import './AmountField.css'

/**
 * Tutar kutusu (22 Eki 2026): Parçalı Öde > Tutarla, Üstü Kalsın ve Alınan
 * para aynı kutuyu kullanıyor. Yazı alanı rakam kadar geniş, TL işareti
 * rakamın hemen yanında ve onunla kayıyor, ikisi birlikte ortada. Ortalı
 * tam genişlik kutuda iPhone imleci yer tutucunun ortasında ya da solda
 * gösteriyordu. Çerçeve dışta; kutunun her yerine dokununca yazmaya
 * geçiliyor (label).
 */
export function AmountField({
  value,
  onChange,
  ariaLabel,
  size = 'md',
  onFocus,
  onKeyDown,
  autoFocus,
}: {
  value: string
  /** Süzülmüş metin (yalnız rakam ve bir virgül). */
  onChange: (text: string) => void
  ariaLabel: string
  size?: 'md' | 'lg'
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
  autoFocus?: boolean
}) {
  return (
    <label className={`amountf amountf--${size}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(amountInput(e.target.value))}
        // Ondalıklı klavye: 7000,50 gibi tutarlar var, düz rakam klavyesinde
        // virgül yok.
        inputMode="decimal"
        placeholder="0"
        style={{ width: `${Math.max(1, (value || '0').length) + 0.1}ch` }}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
        aria-label={ariaLabel}
      />
      <span aria-hidden="true">₺</span>
    </label>
  )
}
